const LOAD_DETAIL_CLIENTS           = 'LOAD_DETAIL_CLIENTS'
const LOAD_DETAIL_CLIENTS_SUCCESS   = 'LOAD_DETAIL_CLIENTS_SUCCESS'
const LOAD_DETAIL_CLIENTS_FAILED    = 'LOAD_DETAIL_CLIENTS_FAILED'
const UNMOUNT_DETAIL_CLIENTS        = 'UNMOUNT_DETAIL_CLIENTS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const clientDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_CLIENTS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_CLIENTS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_CLIENTS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_CLIENTS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default clientDetailReducer;